<template>
  <div v-if="org">
    <div class="details-card__title details-card__title--main d-flex mb-6">
      <div>Company Details</div>
      <apio-icon 
        name="ui-edit"
        class="edit-icon"
        @click.native="editOrganisation"
        lightModeColour="black"
        darkModeColour="white"
      />
    </div>

    <!-- Company Details -->

    <div class="details-card__body--small-title">Registration:</div>

    <div class="details-card__body mb-2 font-weight-semi-bold">{{ org.company_registration_number || '-' }}</div>

    <div class="details-card__body--small-title">VAT number:</div>

    <div class="details-card__body font-weight-semi-bold">{{ org.vat_number || '-' }}</div>
    <!-- End of company details -->
  </div>
</template>

<script>
export default {
  props: {
    org: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    editOrganisation() {
      this.$emit('edit-org')
    }
  }
};
</script>